import { m2mAuthTokenApi } from "./client";
import {
  defaultStorageAdapter,
  PersistenceStorageAdapter,
} from "./persistenceDatabase";

export const createClearAuth =
  (storage: PersistenceStorageAdapter = defaultStorageAdapter) =>
  async () => {
    await storage.clear();
    await m2mAuthTokenApi.clear();
  };
